import { intervalToDuration } from 'date-fns';
import { useEffect, useState } from 'react';
import _ from 'lodash';

import { CONSTANTS } from 'generic/core/constants';

/**
 * Custom hook to calculate and update the duration between two dates in real-time.
 *
 * @param {Date|string} start - The start date of the interval.
 * @param {Date|string} [end] - The end date of the interval. If not provided, the current date and time will be used.
 * @returns {string} - The formatted duration string in 'short' format.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DurationFormat Intl.DurationFormat}
 */
const useLiveDuration = (start, end) => {
  const lang = CONSTANTS.LANG_MAPPING[_.get(window, 'QWAM.localeId', 1)];

  const dur = intervalToDuration({
    start: new Date(start),
    end: end ? new Date(end) : new Date(),
  });

  const init = new Intl.DurationFormat(lang, { style: 'short' }).format(dur);
  const [duration, setDuration] = useState(init);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const d = intervalToDuration({
        start: new Date(start),
        end: end ? new Date(end) : new Date(),
      });

      const ret = new Intl.DurationFormat(lang, { style: 'short' }).format(d);
      setDuration(ret);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [start, end, lang]);

  return duration;
};

export default useLiveDuration;
